require('../../../../Crud/resources/js/form/inputs/switch.js');

// Ajax post for normal cookies
common.View.create('website::partials.Cookies', {

    onDOMLoad()
    {
        this.initModal();
        this.initSendForm();
    },

    initModal()
    {
        // Hide modal, but set to flex. This way we can use the fade effect in CSS and it will be centered
        $('#cookiesModal').css('display', 'flex').hide();

        $('[data-target="#cookiesModal"]')
            .on('click', (event) => {
                $('body').addClass('overflow-hidden')
                    .find('.modals #cookiesModal').fadeIn('fast');

                return false;
            });
    },

    initSendForm()
    {
        this.element.find('form')

            .on('submit', (event) =>
            {
                let allCookies = document.activeElement.getAttribute('name') === 'allCookies' ? 1 : 0;

                $.post('/save-cookies', { allCookies: allCookies })
                    .done(() => {
                        this.element.find('form').hide();

                        // There are checkboxes which also redirect to the cookies module?
                        // If so; we can turn those on automatically
                        let cookieInput = $('[data-target="#cookiesModal"]').data('input');
                        if( cookieInput ) {
                            $('[name^="'+ cookieInput +'"]').prop('checked', true);
                        }
                    });

                // Stop submit
                return false;
            })
            .end();
    }

});

// TODO Critical: Move to own .js?
// Ajax post for modal cookies
common.View.create('website::partials.Modal', {

    onDOMLoad()
    {
        this.initClose();
        this.initSendForm();
    },

    initClose()
    {
        // Click outside of div?
        $('#cookiesModal')
            .on('click', (event) => {
                let container = this.element;

                // Check for click outside div
                if (!container.is(event.target) && container.has(event.target).length === 0) {
                    $('body').removeClass('overflow-hidden')
                        .find('.modals #cookiesModal').fadeOut('fast');
                }
            });

        // Dismiss by close button
        this.element
            .find('[data-dismiss]')
            .on('click', (event) => {
                $('body').removeClass('overflow-hidden')
                    .find('.modals #cookiesModal').fadeOut('fast');
            })
            .end();
    },

    initSendForm()
    {
        this.element.find('form button[type=submit]')

            .on('click', (event) =>
            {
                // Get form data
                let data = this.element.find('form').serializeArray();
                data.push({ name: event.currentTarget.name, value: event.currentTarget.value });

                // Ajax call
                $.post('/save-cookies', data)
                    .done((result) => {
                        // Hide modal
                        $('body').removeClass('overflow-hidden')
                            .find('.modals #cookiesModal').fadeOut('fast');

                        // Hide 'footer' cookies
                        $('.website\\:\\:partials-Cookies').find('form').hide();

                        // There are checkboxes which also redirect to the cookies module?
                        // If so; we can turn those on automatically
                        let cookieInput = $('[data-target="#cookiesModal"]').data('input');
                        if( cookieInput ) {
                            $('[name^="'+ cookieInput +'"]').prop('checked', true);
                        }

                        let acceptedCookies = result.cookies.filter(cookie => cookie.user_accepted);
                        let declinedCookies = result.cookies.filter(cookie => !cookie.user_accepted);

                        this.addCookies(acceptedCookies);
                        this.removeCookies(declinedCookies);

                        // Fire event to update the cookies
                        window.dispatchEvent(new CustomEvent('cookies-accepted'));
                    });

                // Stop submit
                return false;
            })
            .end();
    },

    addCookies(cookies)
    {
        Object.keys(cookies).forEach((key) => {
            let cookie = cookies[key];

            // Check if we need to add JavaScript code
            this.checkAndAddJavascriptCode(cookie.javascript_code);
        });
    },

    removeCookies(cookies)
    {
        Object.keys(cookies).forEach((key) => {
            let cookie = cookies[key];

            // Check if we need to remove JavaScript code
            this.removeJavascriptCode(cookie.javascript_code);
        });
    },

    checkAndAddJavascriptCode(jsCode) {
        // Get the content between the script tags
        const scriptStart = document.getElementById('cookie-scripts-start');
        const scriptEnd = document.getElementById('cookie-scripts-end');

        if( !jsCode ) {
            return;
        }
    
        if (!scriptStart || !scriptEnd) {
            console.error('Script start or end tags are missing');
            return;
        }
    
        // Get all elements between the script start and end tags
        let currentNode = scriptStart.nextSibling;
        let scriptContent = '';
    
        while (currentNode && currentNode !== scriptEnd) {
            if (currentNode.nodeType === Node.TEXT_NODE || currentNode.nodeType === Node.ELEMENT_NODE) {
                scriptContent += currentNode.outerHTML || currentNode.nodeValue;
            }
            currentNode = currentNode.nextSibling;
        }
    
        // Extract the JavaScript content from the user-provided code
        const scriptTagPattern = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
        let match;
        let scriptAdded = false;
    
        while ((match = scriptTagPattern.exec(jsCode)) !== null) {
            const scriptCodeContent = match[1].trim();
            const normalizedScriptContent = scriptContent.replace(/\s+/g, ' ').trim();
            const normalizedJsCode = scriptCodeContent.replace(/\s+/g, ' ').trim();
    
            // Check if the specific JavaScript code content exists in the content
            if (!normalizedScriptContent.includes(normalizedJsCode)) {
                // If the code does not exist, create a new script element and add it to the DOM
                const newScript = document.createElement('script');
                newScript.textContent = scriptCodeContent;
                scriptEnd.parentNode.insertBefore(newScript, scriptEnd);
                scriptAdded = true;
                //console.log('JavaScript code added to the DOM');
            } else {
                //console.log('JavaScript code already exists in the DOM');
            }
        }
    
        if (!scriptAdded) {
            //console.log('No new JavaScript code to add.');
        }
    },

    removeJavascriptCode(jsCode) {
        const scriptStart = document.getElementById('cookie-scripts-start');
        const scriptEnd = document.getElementById('cookie-scripts-end');
    
        if (!scriptStart || !scriptEnd) {
            console.error('Script start or end tags are missing');
            return;
        }
    
        const scriptTagPattern = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
        let match;
    
        while ((match = scriptTagPattern.exec(jsCode)) !== null) {
            const scriptCodeContent = match[1].trim();
    
            let currentNode = scriptStart.nextSibling;
            while (currentNode && currentNode !== scriptEnd) {
                if (currentNode.nodeType === Node.ELEMENT_NODE && currentNode.tagName.toLowerCase() === 'script') {
                    const normalizedCurrentNodeContent = currentNode.textContent.replace(/\s+/g, ' ').trim();
                    const normalizedJsCode = scriptCodeContent.replace(/\s+/g, ' ').trim();
    
                    if (normalizedCurrentNodeContent === normalizedJsCode) {
                        currentNode.parentNode.removeChild(currentNode);
                        console.log('JavaScript code removed from the DOM');
                    }
                }
                currentNode = currentNode.nextSibling;
            }
        }
    }    

});
